export * from './discounts';
export * from './formats';
export * from './platform';

/** Width of the side drawer */
export const drawerWidth = 313;

export const CONTACT_ACC_MANAGER_SUBJECT = {
  OPENING_HOURS: 'Update opening hours',
  UPDATE_PROFILE: 'Update menus or photos',
  UPDATE_DEALS: 'Update offers',
  OTHER: 'Other',
};
